import { useState } from 'react'

export function usePrevious<T>(value: T): T {
  const [previous, setPrevious] = useState(value)
  if (previous !== value) {
    setPrevious(value)
  }
  return previous
}
